import { API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import type { Policy } from '@/shared/types/global.types'

export function getPolicies(token: string): Promise<Policy[]> {
  return apiRequest<Policy[]>(API_PATH.POLICY, token)
}
